<div class="container-fluid mt-4 pt-3 inbox-v3-wrapper">
  <!-- MODAL -->
  <ng-template #contenido let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" style="margin-left: 10px" (click)="modal.dismiss()"
        class="btn btn-info btn-label waves-light">
        <i class="fas fa-sign-out-alt label-icon"></i> Salir
      </button>
    </div>
    <div class="modal-body">
      <app-email-details [WsLlaves]="WsLlaves"></app-email-details>
    </div>
    <div class="modal-footer">
      <button type="button" style="margin-left: 10px" (click)="modal.dismiss()"
        class="btn btn-info btn-label waves-light">
        <i class="fas fa-sign-out-alt label-icon"></i> Salir
      </button>
    </div>
  </ng-template>

  <div class="row mt-4">
    <!-- SIDEBAR -->
    <div class="col-3">
      <div class="card inbox-v3-card">
        <div class="inbox-v3-nav p-3">
          <a href="javascript: void(0);" class="inbox-v3-nav-link" (click)="cambio('N')" [ngClass]="{'active' : emailSelected == 'N'}">
            <i class="fas fa-envelope"></i> <span>No leído</span>
            <span class="inbox-v3-badge">{{cantidadnoleido}}</span>
          </a>
          <a href="javascript: void(0);" class="inbox-v3-nav-link" (click)="cambio('S')" [ngClass]="{'active' : emailSelected == 'S'}">
            <i class="fas fa-envelope-open-text"></i> <span>Leído</span>
            <span class="inbox-v3-badge">{{cantidadleido}}</span>
          </a>
          <a href="javascript: void(0);" class="inbox-v3-nav-link" (click)="cambio('I')" [ngClass]="{'active' : emailSelected == 'I'}">
            <i class="fas fa-star"></i> <span>Importante</span>
            <span class="inbox-v3-badge">{{cantidadImportante}}</span>
          </a>
          <a href="javascript: void(0);" class="inbox-v3-nav-link" (click)="cambio('T')" [ngClass]="{'active' : emailSelected == 'T'}">
            <i class="fas fa-inbox"></i> <span>Todos</span>
            <span class="inbox-v3-badge">{{cantidad}}</span>
          </a>
        </div>
      </div>
    </div>

    <div class="col-9">
      <div class="card inbox-v3-card">
        <div class="inbox-v3-toolbar">
          <div class="btn-group">
            <button type="button" class="inbox-v3-btn-action" (click)="markUnread('S')" title="Marcar leído"><i class="fas fa-envelope-open"></i></button>
            <button type="button" class="inbox-v3-btn-action" (click)="markUnread('N')" title="Marcar no leído"><i class="fas fa-envelope"></i></button>
            <button type="button" class="inbox-v3-btn-action" (click)="markUnread('', 'S')" title="Favorito"><i class="fas fa-star"></i></button>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="inbox-v3-empty" *ngIf="data.length == 0; else registros">
            <i class="fas fa-folder-open mb-3"></i>
            <h5>No hay información que cumpla con los filtros indicados</h5>
          </div>

          <ng-template #registros>
            <div class="inbox-v3-list">

              <div class="inbox-v3-row header-row" style="background:transparent; box-shadow:none; border-bottom: none;">
                <div class="inbox-v3-col-actions">
                  <input type="checkbox" id="inbox-v3-checkall-page" (change)="toggleSelectPage($event)" /> <div><strong>Marcar Todos</strong></div>
                </div>
                <div style="text-align:center;"><!-- espacio para iconos --></div>
              </div>
              <div class="inbox-v3-row"
                   *ngFor="let email of data; let i = index"
                   [ngClass]="{ 'unread': email.PAD14LEO === 'N' }">

                <div class="inbox-v3-col-actions">
                  <input type="checkbox" class="inbox-v3-check" (change)="selectMail($event,email.PAD14CON)"
                         [checked]="emailIds.indexOf(email.PAD14CON) !== -1" />
                  <button type="button" class="btn btn-link p-0" (click)="agregarImportante(email)" title="Importante">
                    <i class="fa-xl fa-star inbox-v3-star" [ngClass]="email.PAD14IMP === 'S' ? 'fas' : 'far'" [ngStyle]="{'color':email.PAD14IMP === 'S' ? '#f4c749' : '' }"></i>
                  </button>
                </div>

                <div class="inbox-v3-col-content" (click)="EventoClickLista(email.PAD14CON)">
                  <div>{{email.PAD14FEV}}</div>
                  <div>{{email.PAD14NEM}}</div>
                  <div>{{email.PAD14ASU}}</div>
                </div>
              </div>

            </div>
          </ng-template>
        </div>

        <!-- Pagination Footer (mantengo tu ngb-pagination y selector tal cual) -->
        <div class="inbox-v3-footer" *ngIf="data.length > 0">
          <ngb-pagination class="pagination-rounded" [collectionSize]="totalRecords" [(page)]="page"
            [pageSize]="pageSize" [maxSize]="5" (pageChange)="onPageChange($event)">
          </ngb-pagination>

          <div class="inbox-v3-records">
            <span>Mostrando</span>
            <select class="form-select mx-2" (change)="countNumber($event.target.value)">
              <option *ngFor="let number of number">{{number}}</option>
            </select>
            <span>Registros</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-scroll-to-top></app-scroll-to-top>